export function debounce(
func,
wait,
immediate)
{
  let timeoutId;

  return function debounced(

  ...parameters)
  {
    const later = () => {
      timeoutId = undefined;
      if (!immediate) {
        return func.apply(this, parameters);
      }
      return undefined;
    };

    const callNow = immediate && !timeoutId;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(later, wait);

    if (callNow) {
      return func.apply(this, parameters);
    }

    return undefined;
  };
}